import { PlessViewUtils } from './utils/pless-view-utils.service';

export class PlessViewHelper {

  constructor(
  ) {
    // ブラウザの「戻る」を禁止する
    PlessViewUtils.backBlock();
  }

  /**
   * 画面を閉じるときに実行する処理
   */
  closeFunction: Function;

  /**
   * 「閉じる」ボタン押下時の処理。閉じる際の処理をカスタマイズする場合はこれをオーバーライドする
   */
  onClickClose() {
    if (this.closeFunction != null) {
      this.closeFunction();
    } else {
      console.log('closeFunctionが指定されていません');
    }
  }

  /* 子画面用処理 */
  /**
   * 「×」ボタンが押下された時の処理(デフォルトでは「閉じる」ボタン押下時の処理を呼ぶ)
   */
  onClickWindowClose() {
    this.onClickClose();
  }
  /**
   * 子ウインドウから親にドラッグ操作を伝播させない為の処理
   */
  onDragstartBody(event: DragEvent) {
    /* ウインドウ操作を阻害しないようにイベントを無効化し、伝播をキャンセルする */
    event.preventDefault();   // イベントを無効化
    event.stopPropagation();  // 上位へのイベントの伝播をキャンセル
  }

  /**
   * 指定IDの項目にフォーカスを当てる
   * @param id フォーカスをセットする項目のid
   */
  setFocusById(id: string) {
    document.getElementById(id).focus();
  }

  /**
   * 親画面に対して公開し、親画面からのパラメタを受け取るためのメソッド
   *
   * @param {*} param 受け渡すデータ
   * @memberof SampleWindowComponent
   */
  public setInterfaceParam(param: any): void {
  }

}
